'use strict';

var init = function() {
	require('jquery/dist/jquery');
	window.$ = window.jQuery = require('jquery');
	require('jquery.cookie'); // jQuery Cookie
	require('bootstrap/dist/js/bootstrap');
	require('bootstrap-sass-datepicker/js/bootstrap-sass-datepicker');

	window.enableVideoApi = false; // Flag to turn off Video API for third party and use html5 instead
};

module.exports =  {
	init: init
};
